import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Carousel,
  Button
} from '@lockerpm/design';

import {
  UpOutlined,
  DownOutlined,
  CloseOutlined
} from '@ant-design/icons'

import images from '../../assets/images';

import global from '../../config/global';
import resourceServices from '../../services/resource';
import common from '../../utils/common';

import '../../web-sh/src/layouts/css/footer.scss';

function Footer(props) {
  const { t } = useTranslation();
  const { BannerIcon } = images;

  const {
    className = '',
    showFooter = false,
    setShowFooter = () => {}
  } = props;

  const isMobile = useSelector((state) => state.system.isMobile);
  const locale = useSelector((state) => state.system.locale);

  const [data, setData] = useState([]);

  const carouselRef = useRef(null)

  useEffect(() => {
    fetchData();
  }, []);

  const filteredData = useMemo(() => {
    if (locale === global.constants.LANGUAGE.VI) {
      return data.filter((d) => d.Language == 'Vietnamese' && d.Status == 'Active')
    }
    if (locale === global.constants.LANGUAGE.EN) {
      return data.filter((d) => d.Language == 'English' && d.Status == 'Active')
    }
    if (locale === global.constants.LANGUAGE.ZH) {
      return data.filter((d) => d.Language == 'Chinese' && d.Status == 'Active')
    }
    if (locale === global.constants.LANGUAGE.RU) {
      return data.filter((d) => d.Language == 'Russian' && d.Status == 'Active')
    }
    return []
  }, [data, locale])

  useEffect(() => {
    setShowFooter(filteredData.length > 0);
  }, [filteredData]);

  const fetchData = async () => {
    const res = await resourceServices.get_banner({});
    setData(res || []);
  }

  return (
    <>
      {
        filteredData.length > 0 && showFooter && <div
          className={`${className} ${isMobile  ? 'mobile' : ''}`}
        >
          <div className='flex items-center h-full w-full gap-3'>
            <div className='flex items-center'>
              {
                filteredData.length > 1 && <div className='mr-4 h-full'>
                  <div
                    className='h-1/2 flex items-center hover:text-primary hover:font-semibold cursor-pointer'
                    onClick={() => carouselRef?.current?.next()}
                  >
                    <UpOutlined />
                  </div>
                  <div
                    className='h-1/2 flex items-center hover:text-primary hover:font-semibold cursor-pointer'
                    onClick={() => carouselRef?.current?.prev()}
                  >
                    <DownOutlined />
                  </div>
                </div>
              }
              <img src={BannerIcon}></img>
            </div>
            <div style={{ width: 'calc(100% - 120px)' }} className='h-full flex items-center'>
              <Carousel
                ref={carouselRef}
                className={filteredData.length === 1 ? `carousel-footer h-full` : ''}
                dotPosition="left"
                autoplay={true}
                dots={false}
              >
                {
                  filteredData.map((d, index) => <div
                    key={index}
                    className='flex items-center justify-between w-full'
                  >
                    <div className='flex items-center justify-between w-full h-full'>
                      <span className='text-limited' title={d.Text}>{d.Text} 🎉</span>
                      <Button
                        type="primary"
                        ghost
                        onClick={() => common.openNewTab(d.Link)}
                      >
                        {t('button.learn_more')}
                      </Button>
                    </div>
                  </div>)
                }
              </Carousel>
            </div>
            <div>
              <Button
                type="text"
                onClick={() => setShowFooter(false)}
                icon={<CloseOutlined />}
              >
              </Button>
            </div>
          </div>
        </div>
      }
    </>
  );
}

export default Footer;
